export class MmdDataSerializer {
    _dataView;
    _encoder;
    _offset;
    constructor(arrayBuffer) {
        this._dataView = new DataView(arrayBuffer);
        this._encoder = new TextEncoder();
        this._offset = 0;
    }
    get offset() {
        return this._offset;
    }
    set offset(value) {
        this._offset = value;
    }
    setUint8(value) {
        this._dataView.setUint8(this._offset, value);
        this._offset += 1;
    }
    setUint8Array(values) {
        const dataView = this._dataView;
        for (let i = 0; i < values.length; ++i) {
            dataView.setUint8(this._offset, values[i]);
            this._offset += 1;
        }
    }
    setInt8(value) {
        this._dataView.setInt8(this._offset, value);
        this._offset += 1;
    }
    setInt8Array(values) {
        const dataView = this._dataView;
        for (let i = 0; i < values.length; ++i) {
            dataView.setInt8(this._offset, values[i]);
            this._offset += 1;
        }
    }
    setUint16(value) {
        this._dataView.setUint16(this._offset, value, true);
        this._offset += 2;
    }
    setUint16Array(values) {
        const dataView = this._dataView;
        for (let i = 0; i < values.length; ++i) {
            dataView.setUint16(this._offset, values[i], true);
            this._offset += 2;
        }
    }
    setUint32(value) {
        this._dataView.setUint32(this._offset, value, true);
        this._offset += 4;
    }
    setUint32Array(values) {
        const dataView = this._dataView;
        for (let i = 0; i < values.length; ++i) {
            dataView.setUint32(this._offset, values[i], true);
            this._offset += 4;
        }
    }
    setInt32(value) {
        this._dataView.setInt32(this._offset, value, true);
        this._offset += 4;
    }
    setInt32Array(values) {
        const dataView = this._dataView;
        for (let i = 0; i < values.length; ++i) {
            dataView.setInt32(this._offset, values[i], true);
            this._offset += 4;
        }
    }
    setFloat32(value) {
        this._dataView.setFloat32(this._offset, value, true);
        this._offset += 4;
    }
    setFloat32Array(values) {
        const dataView = this._dataView;
        for (let i = 0; i < values.length; ++i) {
            dataView.setFloat32(this._offset, values[i], true);
            this._offset += 4;
        }
    }
    setString(value) {
        const dataView = this._dataView;
        const bytes = this._encoder.encode(value);
        dataView.setUint32(this._offset, bytes.length, true);
        this._offset += 4;
        for (let i = 0; i < bytes.length; ++i) {
            dataView.setUint8(this._offset, bytes[i]);
            this._offset += 1;
        }
    }
    get bytesAvailable() {
        return this._dataView.byteLength - this._offset;
    }
    static Padding(offset, elementSize) {
        return offset % elementSize === 0 ? 0 : elementSize - offset % elementSize;
    }
}
